import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'

export interface MaintenanceModeStatus {
  isActive: boolean
  message: string
}

export const MAINTENANCE_QUERY_KEY = ['system.maintenance']

export function useQueryMaintenanceMode() {
  return useQuery<MaintenanceModeStatus>({
    queryKey: MAINTENANCE_QUERY_KEY,
    queryFn: async () => {
      const { data } = await axiosInstance.get('/config-api/system/maintenance')
      return data
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
